import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { DialogMergeConfirmationData } from './models/dialog-merge-confirmation-data';

import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-merge-confirmation',
    templateUrl: './merge-confirmation.component.html',
    styleUrls: ['./merge-confirmation.component.scss'],
    imports: [MatCardModule, MatButtonModule, MatDialogClose]
})
export class MergeConfirmationComponent {
    /**
     * Constructeur.
     * @param dialogRef
     * @param data
     */
    constructor(
        public dialogRef: MatDialogRef<MergeConfirmationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogMergeConfirmationData
    ) {}
}
